import request from '@/utils/request'

// 创建/获取客服会话（页面自带连接中状态，不弹全局加载中）
export const createChatSessionApi = () => {
  return request.post('/chat/createSession', {}, { silent: true })
}

// 用户发送消息（msgType: 1=文本 2=图片）
export const sendChatMessageApi = (sessionId, content, msgType = 1) => {
  return request.post('/chat/send', {
    sessionId,
    content,
    msgType
  })
}

// 上传聊天图片，返回 { url }
export const uploadChatImageApi = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 拉取消息（增量）— 高频轮询，不弹加载中
// markRead=1 仅在聊天页使用：拉取即视为用户已读，推进服务端「买家已读游标」（客服端消息回执用）
export const getChatMessagesApi = (sessionId, after = 0, markRead = 0) => {
  return request.get(`/chat/messages?sessionId=${sessionId}&after=${after}&markRead=${markRead ? 1 : 0}`, { silent: true })
}

// 我的会话列表 — 高频轮询，不弹加载中
export const getChatSessionsApi = () => {
  return request.get('/chat/sessions', { silent: true })
}
